<template>
    <div class="search-form">
        <input type="text" v-model="getSearch" class="inputfield" :placeholder="$t('generic.search')" />
        <button class="search-form--clear" @click.prevent="clearSearch()" v-if="search != ''"></button>
    </div>
</template>

<script>
export default {
    name : "SearchField",
    props: {
        search: {
            type: String,
            default: ""
        }
    },

    computed: {
        getSearch: {
            get : function() {
                return this.search;
            },
            set : function(value) {
                this.$emit("update:search", value);
            }
        }
    },

    methods: {
        clearSearch() {
            this.getSearch = "";
        }
    }
};
</script>

<style lang="scss" scoped>
    .search-form {
        position: relative;
        display: flex;
        justify-content: flex-end;

        input {
            margin-bottom: 0px;
            width : 80%;
        }

        &--clear {
            @extend .reset-btn;
            position: absolute;
            right : 0.5rem;
            height : 2rem;
            width : 2rem;
            margin-top : .5rem;
            background-image : url('/img/icon-reset.svg');
            background-repeat: no-repeat;
            background-size: 50%;
            background-position: center;
            opacity: .5;
        }
    }
</style>